import { useEffect, useRef, useState } from 'react';
import { OTP_RESEND_LOCK } from '../constants';
export const useOtpResendLock = ()=>{
    const intervalRef = useRef(null);
    const [resendLock, setResendLock] = useState(OTP_RESEND_LOCK);
    const resendCountdown = ()=>{
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(()=>{
            setResendLock((prev)=>{
                if (prev <= 1) {
                    clearInterval(intervalRef.current);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };
    const setLock = ()=>{
        setResendLock(OTP_RESEND_LOCK);
        resendCountdown();
    };
    useEffect(()=>{
        resendCountdown();
        return ()=>clearInterval(intervalRef.current);
    }, []);
    return {
        resendLock,
        setResendLock: setLock
    };
};
